import type { TFunction } from 'i18next';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

const isFetchBaseQueryError = (err: unknown): err is FetchBaseQueryError =>
  typeof err === 'object' && err !== null && 'status' in err;

/**
 * Traduce el rechazo de `restorePassword` o `confirmUsername` (NestJS) a algo
 * que el vendedor pueda leer (VWA-37).
 *
 * Es una excepción documentada a «no mostrar el texto del backend»: estos dos
 * servicios responden mensajes escritos para la pantalla, en español, y que ya
 * cuidan no revelar de más («Datos no válidos», «El número introducido no está
 * registrado…», el del estatus de la cuenta, «Tu solicitud expiró…»). Son los
 * mismos que muestra la app.
 *
 * - Mensaje de texto: se muestra tal cual.
 * - Lista de mensajes: es la validación del DTO, en inglés. No se muestra.
 * - Sin respuesta HTTP: falla de transporte.
 */
export const resolveRecoveryError = (err: unknown, t: TFunction): string => {
  if (!isFetchBaseQueryError(err) || typeof err.status !== 'number') {
    return t('errors.apiError');
  }

  const body = err.data as { message?: unknown } | undefined;
  const message = typeof body?.message === 'string' ? body.message.trim() : '';

  return message || t('errors.invalidData');
};
